module.exports = __webpack_public_path__ + "static/media/IMG-17.31cd032b.jpg";